import { Component, Prop } from  'vue-property-decorator' ;
import { ContentLoader } from 'vue-content-loader' ;
import LoaderPalette from "../../../../components/loader-palette";




@Component({
    components: { 
        ContentLoader
    }
})
class ProfileNotificationTypeLoader extends LoaderPalette {

    @Prop({ required: true, type: [String] })
    loaderType: string

    constructor(){
        super()
    }
}

export default ProfileNotificationTypeLoader


// WEBPACK FOOTER //
// ./src/containers/profile/loaders/profile-notification-type-loader/index.ts